
import { ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ExpandToggleButtonProps {
  isExpanded: boolean;
  onClick: () => void;
}

const ExpandToggleButton = ({ isExpanded, onClick }: ExpandToggleButtonProps) => {
  return (
    <Button
      variant="ghost"
      size="sm"
      className="h-8 mt-1 text-xs font-medium hover:bg-secondary/50 group relative"
      onClick={onClick}
      aria-expanded={isExpanded}
      aria-controls="message-content"
    >
      {isExpanded ? (
        <span className="flex items-center text-muted-foreground group-hover:text-foreground transition-colors">
          <ChevronUp className="h-4 w-4 mr-1.5" /> 
          <span>Show less</span>
        </span>
      ) : (
        <span className="flex items-center text-primary group-hover:text-primary/80 transition-colors">
          <ChevronDown className="h-4 w-4 mr-1.5" /> 
          <span>Show full message</span>
          <span className="absolute inset-0 bg-primary/5 opacity-0 group-hover:opacity-100 rounded-md transition-opacity -z-10"></span>
        </span>
      )}
    </Button>
  );
};

export default ExpandToggleButton;
